import React from "react";
import { money } from "@/lib/api";

export function SpendNudge({ subtotal }) {
  const target = 110;
  const reached = subtotal >= target;
  const pct = Math.min(100, (subtotal / target) * 100);
  const remaining = Math.max(0, target - subtotal);

  return (
    <div
      className={`rounded-[16px] px-4 py-3 ${reached ? "bg-[#0B7A3B] text-white" : "bg-white border border-[#DDF0E5]"}`}
      data-testid="spend-nudge"
    >
      <div className="flex items-center justify-between mb-2">
        <span className={`text-sm font-bold ${reached ? "text-white" : "text-[#122117]"}`}>
          {reached ? "🎉 15% rate unlocked!" : `Add ${money(remaining)} more`}
        </span>
        <span className={`text-xs ${reached ? "text-white/80" : "text-[#6B8375]"}`}>
          {reached ? "Best value" : "to unlock the 15% rate"}
        </span>
      </div>
      <div className={`h-2.5 rounded-full overflow-hidden ${reached ? "bg-white/25" : "bg-[#F5F8F6]"}`}>
        <div
          className={`h-full rounded-full transition-[width] duration-500 ${reached ? "bg-white" : "bg-[#0B7A3B]"}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
